export const circleList = [
  "Andhra Pradesh",
  "Assam",
  "Bihar / Jharkhand",
  "Chennai",
  "Delhi NCR",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu Kashmir",
  "Karnataka",
  "Kerala",
  "Kolkata",
  "Madhya Pradesh / Chhattisgarh",
  "Meghalay",
  "Mizzoram",
  "Maharashtra",
  "Mumbai",
  "North East",
  "Orissa",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Tripura",
  "UP East",
  "UP West",
  "West Bengal",
];
